import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { LineContainerComponent } from "shared-ui-components/lines/lineContainerComponent";
import { CheckBoxLineComponent } from "../../sharedComponents/checkBoxLineComponent";
import { TextInputLineComponent } from "shared-ui-components/lines/textInputLineComponent";
import { Vector2LineComponent } from "shared-ui-components/lines/vector2LineComponent";
import { OptionsLine } from "shared-ui-components/lines/optionsLineComponent";
import { TextLineComponent } from "shared-ui-components/lines/textLineComponent";
import { FloatLineComponent } from "shared-ui-components/lines/floatLineComponent";
import { SliderLineComponent } from "shared-ui-components/lines/sliderLineComponent";
import { Vector3LineComponent } from "shared-ui-components/lines/vector3LineComponent";
import { ForceRebuild } from "shared-ui-components/nodeGraphSystem/automaticProperties";
import { NodeParticleBlockConnectionPointTypes } from "core/Particles/Node/Enums/nodeParticleBlockConnectionPointTypes";
import { Color4LineComponent } from "shared-ui-components/lines/color4LineComponent";
/**
 *
 */
export class GenericPropertyComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsx(GeneralPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData }), _jsx(GenericPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData })] }));
    }
}
/**
 *
 */
export class GeneralPropertyTabComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    processUpdate() {
        this.props.stateManager.onRebuildRequiredObservable.notifyObservers();
    }
    renderConnectionPoint(point) {
        switch (point.type) {
            case NodeParticleBlockConnectionPointTypes.Vector2:
                return (_jsx(Vector2LineComponent, { lockObject: this.props.stateManager.lockObject, label: point.name, target: point, propertyName: "value", onChange: () => this.processUpdate() }, point.name));
            case NodeParticleBlockConnectionPointTypes.Vector3:
                return (_jsx(Vector3LineComponent, { lockObject: this.props.stateManager.lockObject, label: point.name, target: point, propertyName: "value", onChange: () => this.processUpdate() }, point.name));
            case NodeParticleBlockConnectionPointTypes.Color4:
                return (_jsx(Color4LineComponent, { lockObject: this.props.stateManager.lockObject, label: point.name, target: point, propertyName: "value", onChange: () => this.processUpdate() }, point.name));
        }
        return null;
    }
    render() {
        const block = this.props.nodeData.data;
        const nonConnectedInputs = block.inputs.filter((input) => {
            return !input.isConnected && input.value !== null && input.value !== undefined;
        });
        const projectedProperties = [NodeParticleBlockConnectionPointTypes.Float, NodeParticleBlockConnectionPointTypes.Int];
        return (_jsxs(_Fragment, { children: [_jsxs(LineContainerComponent, { title: "GENERAL", children: [_jsx(TextInputLineComponent, { label: "Name", propertyName: "name", target: block, lockObject: this.props.stateManager.lockObject, onChange: () => this.props.stateManager.onUpdateRequiredObservable.notifyObservers(block), throttlePropertyChangedNotification: true, validator: () => {
                                return true;
                            } }), _jsx(TextLineComponent, { label: "Type", value: block.getClassName() }), _jsx(TextInputLineComponent, { label: "Comments", propertyName: "comments", lockObject: this.props.stateManager.lockObject, target: block, onChange: () => this.props.stateManager.onUpdateRequiredObservable.notifyObservers(block), throttlePropertyChangedNotification: true })] }), nonConnectedInputs.filter((p) => projectedProperties.indexOf(p.type) === -1 && (!p._defaultConnectionPointType || projectedProperties.indexOf(p._defaultConnectionPointType) !== -1)).length > 0 && (_jsx(LineContainerComponent, { title: "PROPERTIES", children: nonConnectedInputs.map((input) => {
                        return this.renderConnectionPoint(input);
                    }) }))] }));
    }
}
/**
 *
 */
export class GenericPropertyTabComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const block = this.props.nodeData.data, propStore = block._propStore;
        if (!propStore) {
            return _jsx(_Fragment, {});
        }
        const componentList = {}, groups = [];
        const classes = [];
        let proto = Object.getPrototypeOf(block);
        while (proto && proto.getClassName) {
            classes.push(proto.getClassName());
            proto = Object.getPrototypeOf(proto);
        }
        for (const { propertyName, displayName, type, groupName, options, className } of propStore) {
            let components = componentList[groupName];
            if (classes.indexOf(className) === -1) {
                continue;
            }
            if (!components) {
                components = [];
                componentList[groupName] = components;
                groups.push(groupName);
            }
            switch (type) {
                case 0 /* PropertyTypeForEdition.Boolean */: {
                    components.push(_jsx(CheckBoxLineComponent, { label: displayName, target: block, propertyName: propertyName, onValueChanged: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `checkBox-${propertyName}`));
                    break;
                }
                case 1 /* PropertyTypeForEdition.Float */: {
                    const cantDisplaySlider = isNaN(options.min) || isNaN(options.max) || options.min === options.max;
                    if (cantDisplaySlider) {
                        components.push(_jsx(FloatLineComponent, { lockObject: this.props.stateManager.lockObject, label: displayName, propertyName: propertyName, target: block, onChange: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `float-${propertyName}`));
                    }
                    else {
                        components.push(_jsx(SliderLineComponent, { lockObject: this.props.stateManager.lockObject, label: displayName, target: block, propertyName: propertyName, step: Math.abs(options.max - options.min) / 100.0, minimum: Math.min(options.min, options.max), maximum: options.max, onChange: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `slider-${propertyName}`));
                    }
                    break;
                }
                case 2 /* PropertyTypeForEdition.Int */: {
                    const cantDisplaySlider = isNaN(options.min) || isNaN(options.max) || options.min === options.max;
                    if (cantDisplaySlider) {
                        components.push(_jsx(FloatLineComponent, { lockObject: this.props.stateManager.lockObject, digits: 0, step: "1", isInteger: true, label: displayName, propertyName: propertyName, target: block, onChange: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `int-${propertyName}`));
                    }
                    else {
                        components.push(_jsx(SliderLineComponent, { lockObject: this.props.stateManager.lockObject, label: displayName, target: block, step: 1, decimalCount: 0, propertyName: propertyName, minimum: Math.min(options.min, options.max), maximum: options.max, onChange: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `slider-${propertyName}`));
                    }
                    break;
                }
                case 3 /* PropertyTypeForEdition.Vector2 */: {
                    components.push(_jsx(Vector2LineComponent, { lockObject: this.props.stateManager.lockObject, label: displayName, propertyName: propertyName, target: block, onChange: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `vector2-${propertyName}`));
                    break;
                }
                case 5 /* PropertyTypeForEdition.List */: {
                    components.push(_jsx(OptionsLine, { label: displayName, options: options.options, target: block, propertyName: propertyName, onSelect: () => ForceRebuild(block, this.props.stateManager, propertyName, options.notifiers) }, `options-${propertyName}`));
                    break;
                }
            }
        }
        return (_jsx(_Fragment, { children: groups.map((group) => (_jsx(LineContainerComponent, { title: group, children: componentList[group] }, `group-${group}`))) }));
    }
}
//# sourceMappingURL=genericNodePropertyComponent.js.map